<template>
    <div id="main" class="row DISCption">
        <div id="mySidenav" class="sidenav">
            <ul class="noti">
                <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
                <li>
                    <a href="">Success</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
       
    }
</script>
